<script>
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { getPath } from '../../utils/imageKit.ts';

  let { icon, content, link = undefined, alignment = 'left', dataTestId = 'content-single-blurb' } = $props();

  // Handle Image Setup
  const smSrc = getPath(icon, { w: 52, ar: '1:1' });
  const mdSrc = getPath(icon, { w: 52, ar: '1:1' }, 2);
  const lgSrc = getPath(icon, { w: 144, ar: '1:1' });
  const xlSrc = getPath(icon, { w: 144, ar: '1:1' }, 2);
</script>

<div
  class="my-4 px-4 flex justify-start items-start"
  data-testid={dataTestId}
  class:flex-row-reverse={alignment === 'right'}
  class:flex-row={alignment === 'left'}
>
  <div class="mb-6 w-36">
    <img
      class="object-contain object-left h-full w-36"
      loading="lazy"
      src={smSrc}
      alt={icon.alt}
      width="48"
      height="48"
      srcset={`${smSrc} 52w, ${mdSrc} 104w, ${lgSrc} 144w, ${xlSrc} 288w`}
      sizes="(min-width: 768px) 144px, 52px"
    />
  </div>
  <div class="grow" class:mr-4={alignment === 'right'} class:ml-4={alignment === 'left'}>
    <div class=" lg:text-lg leading-tight text-blue-navy">
      {@html content}
    </div>
    {#if link && link.text && link.url}
      <div class="mt-2 lg:mt-4">
        <BaseLink
          className="leading-normal font-semibold text-blue-cerulean lg:text-lg hover-hover:hover:text-blue-darkish hover-hover:hover:underline
          active:text-blue-darkish active:underline group inline-flex justify-start flex-row w-auto"
          {...link}
        >
          <span>{link.text}</span>
          <svg
            class="ml-3 h-3 w-3 lg:h-5 lg:w-5 mt-1 lg:mt-1.25 fill-current text-blue-cerulean
            hover-hover:group-hover:text-blue-darkish group-active:text-blue-darkish"
          >
            <use xlink:href={`${SPRITESHEET_URL}#right-arrow`} />
          </svg>
        </BaseLink>
      </div>
    {/if}
  </div>
</div>
